export const UPDATE_OPPORTUNITY_COUNT = 'UPDATE_OPPORTUNITY_COUNT';

const updateOpportunityCount = count => (
  (dispatch) => {
    dispatch({
      type: UPDATE_OPPORTUNITY_COUNT,
      count,
    });
  }
);

export default updateOpportunityCount;
